






































import { computed, defineComponent } from '@vue/composition-api';

import PlansList from '../../components/payment/plans/PlansList.vue';
import { useI18n, useStore } from '../../composables';
import { usePlans } from '../../components/payment/plans/plans.hook';
import { SubscriptionService } from '@ligo/dashboard/customer/store';
import { HeroBanner } from '../../components/base/banners';
import { legalPlansPageInformation } from '../../components/utils/useCustomerPageInformation.hooks';
import BasePage from '../../components/base/BasePage.vue';
import { simpleNotification } from '@ligo/shared/utils';
import { SubscriptionType } from '@ligo/shared/auth';

const PLATFORM_AWARD = '/dashboard/images/ligo_shield.svg';
const TAX_AWARD = '/dashboard/images/award_winning.png';

export default defineComponent({
  name: 'PackagesPage',
  components: { PlansList, HeroBanner, BasePage },
  setup() {
    const store = useStore();

    const {
      visiblePlans,
      currentPlan,
      activePlan,
      loading,
      showLegacyBanner
    } = usePlans();

    const i18n = useI18n();

    const visiblePlansLength = computed(() => {
      return visiblePlans.value.length;
    });

    const { t, isReady, load } = legalPlansPageInformation;

    load();

    function onPay(plan: SubscriptionType) {
      activePlan.value = plan.id;

      async function onPlanSelected() {
        const data = (await SubscriptionService.changeSubscription(plan.id))
          .data;

        if (data.payments.length === 1) {
          const payment = data.payments[0];
          store.dispatch('layout/openPaymentModal', {
            paymentUuid: payment.uuid
          });
        } else {
          simpleNotification(i18n.t('account.profile.downgrade_success'));
        }
      }
      onPlanSelected();
    }

    const bannersAwards = computed(() => [
      {
        text: t('tax_award'),
        img: TAX_AWARD
      },
      {
        text: t('platform_award'),
        img: PLATFORM_AWARD
      }
    ]);

    return {
      visiblePlans,
      currentPlan,
      activePlan,
      onPay,
      isReady,
      t,
      showLegacyBanner,
      visiblePlansLength,
      loading,
      bannersAwards
    };
  }
});
